import { useTranslate } from '@tolgee/react';
import React, { FC, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import TextEditorCard from '../cards/textEditorCard';
import { lomavisShowToastr } from '../../../../../utils/ui/toastr';

interface CaptionModalProps {
  show: boolean;
  onClose: () => void;
  onCreate: (data: {
    title: string;
    text_as_html?: string;
    text_quill?: string;
  }) => void;
  action: 'edit' | 'create';
  title?: string;
  quillText?: any;
}

const CaptionModal: FC<CaptionModalProps> = ({
  show,
  onClose,
  onCreate,
  action,
  title = '',
  quillText
}) => {
  const { t } = useTranslate();
  const [editorContent, setEditorContent] = useState({
    text: null,
    text_as_html: ''
  });

  const [captionName, setCaptionName] = useState('');
  console.log('csdsds', quillText);
  useEffect(() => {
    setCaptionName(title);

    setEditorContent((prevState) => ({ ...prevState, text: quillText }));
  }, [title, quillText]);

  const quillHasContent = (rawDelta) => {
    console.log('delataaa'), rawDelta;
    const ops = rawDelta?.ops || [];

    return ops.some(
      (op: any) =>
        typeof op.insert === 'string'
          ? op.insert.trim() !== ''
          : typeof op.insert === 'object' // e.g., mentions
    );
  };

  const handleSubmit = () => {
    if (captionName.trim() && quillHasContent(editorContent.text)) {
      onCreate({
        title: captionName.trim(),
        text_as_html: editorContent.text_as_html,
        text_quill: editorContent.text
      });
      setCaptionName('');
      onClose();
    } else {
      lomavisShowToastr(
        t('lomavisCreator.textBlock.err_emptyTextorTitle'),
        'error'
      );
    }
  };

  const handleClose = () => {
    setCaptionName('');
    setEditorContent({
      text: null,
      text_as_html: ''
    });
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {action === 'create'
            ? t('lomavisCreator.textBlock.createCaption')
            : t('lomavisCreator.textBlock.editCaption')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-2">
        <Form.Group>
          <Form.Label>{t('lomavisCreator.textBlock.captionName')}</Form.Label>
          <Form.Control
            type="text"
            value={captionName}
            onChange={(e) => setCaptionName(e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>{t('lomavisCreator.textBlock.captionText')}</Form.Label>

          <TextEditorCard
            title="title"
            showEmoji={true}
            editorContent={editorContent}
            setEditorContent={setEditorContent}
            quillText={quillText}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('lomavisCreator.textBlock.cancel')}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {action === 'create'
            ? t('lomavisCreator.textBlock.create')
            : t('lomavisCreator.textBlock.edit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CaptionModal;
